/**
 * 通知的**关系档位**——收件人与这件事的关系（**不是**业务失败码）。
 *
 * ⚠️ **为什么单开一张表**：业务失败码（`account_banned` / `busy` / …）在
 * `reasonVocabulary.ts`，那张表描述「**事情为什么失败**」；本表描述
 * 「**你与这件事什么关系**」。两者维度不同，混进一张表会让两套语义互相污染。
 *
 * 取值与后端 `backend/src/notifications/service.py` 的 `REASON_*` 常量逐字对应
 * （优先级 waiter > anchor > extra > related）。
 */
export const NOTIFICATION_RELATIONS = ['waiter', 'anchor', 'extra', 'related'] as const;
export type NotificationRelation = (typeof NOTIFICATION_RELATIONS)[number];

const RELATION_KEY: Record<NotificationRelation, string> = {
  waiter: 'notifications.relation.waiter',
  anchor: 'notifications.relation.anchor',
  extra: 'notifications.relation.extra',
  related: 'notifications.relation.related',
};

/** 关系档位 → i18n 键；不认识的值返回 `null`（调用方决定兜底）。 */
export function notificationRelationKey(reason: string): string | null {
  return RELATION_KEY[reason.trim().toLowerCase() as NotificationRelation] ?? null;
}
